<template>
	<template v-if="['administrator'].includes(getUserRole)">
		<button class="btn btn--color" @click="showPopup = !showPopup">Добавить категорийного менеджера</button>
		<transition name="modal">
			<AddCategoryManagerPopup :productGroups="productGroups" v-if="showPopup" @close="showPopup = false" />
		</transition>
	</template>
</template>
<script>
import AddCategoryManagerPopup from "@/components/sections/CategoryManagers/AddCategoryManagerPopup.vue";
import {mapGetters} from "vuex";

export default {
	name: "ManagersAdd",
	components: {AddCategoryManagerPopup},
	props: {
		productGroups: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showPopup: false
		}
	},
	computed: {
		...mapGetters({
			getUserRole: 'user/getUserRole',
		})
	}
}
</script>


